import { siteStats } from "@/mocks/trending";
import { categories } from "@/mocks/categories";

interface HeroProps {
  search: string;
  onSearchChange: (v: string) => void;
  onSearchSubmit: () => void;
}

const popular = ["明星爆料", "搞笑合集", "社会事件", "网红日常", "实拍现场", "综艺名场面"];

export default function Hero({ search, onSearchChange, onSearchSubmit }: HeroProps) {
  const totalCount = categories.reduce((sum, c) => sum + c.count, 0);

  return (
    <section
      id="home"
      className="relative overflow-hidden bg-gradient-to-br from-accent-100/70 via-background-50 to-secondary-100/60"
    >
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 right-0 h-80 w-80 rounded-full bg-primary-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 pb-14 pt-12 md:px-6 md:pt-16 lg:grid-cols-[1.12fr_0.88fr] lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-background-50/80 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-fire-fill text-accent-500"></i>
            全网瓜料 · 分类整理 · 每日更新
          </span>

          <h1 className="mt-5 max-w-2xl text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            吃瓜不迷路，
            <br className="hidden sm:block" />
            <span className="text-primary-600">全网热点</span>一网打尽
          </h1>

          <p className="mt-5 max-w-xl text-base leading-8 text-foreground-700">
            从娱乐八卦、明星爆料到社会事件、网红日常、搞笑合集与实拍现场，我们把散落在全网的热门瓜料按主题归类，
            想找哪类瓜直接进对应分类，分类清晰、省时省力。
          </p>

          <form
            className="mt-7 flex max-w-xl items-center overflow-hidden rounded-full border border-secondary-300 bg-background-50 p-1.5 shadow-soft focus-within:border-primary-400"
            onSubmit={(e) => {
              e.preventDefault();
              onSearchSubmit();
            }}
          >
            <i className="ri-search-line pl-4 text-lg text-foreground-500"></i>
            <input
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              type="text"
              placeholder="输入明星、事件或分类关键词，快速找瓜…"
              className="min-w-0 flex-1 bg-transparent px-3 py-2.5 text-sm outline-none placeholder:text-foreground-500"
            />
            <button
              type="submit"
              className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line"></i>
              去搜瓜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-foreground-600">大家都在看</span>
            {popular.map((p) => (
              <button
                key={p}
                onClick={() => {
                  onSearchChange(p);
                  onSearchSubmit();
                }}
                className="whitespace-nowrap rounded-full border border-secondary-300 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                #{p}
              </button>
            ))}
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-3 border-t border-background-300/70 pt-6 sm:grid-cols-4">
            {siteStats.map((s) => (
              <div key={s.label}>
                <dt className="text-xs text-foreground-600">{s.label}</dt>
                <dd className="mt-1 font-heading text-lg font-extrabold text-foreground-950">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative hidden lg:block">
          <div className="relative overflow-hidden rounded-[1.6rem] shadow-soft">
            <img
              src="https://readdy.ai/api/search-image?query=Colorful%20flat%20editorial%20vector%20illustration%20of%20entertainment%20media%20theme%20with%20television%20screen%2C%20microphone%2C%20video%20camera%2C%20floating%20speech%20bubbles%2C%20popcorn%20and%20shooting%20stars%20arranged%20in%20a%20lively%20magazine%20collage%2C%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=820&height=1000&seq=hero-visual&orientation=portrait"
              alt="吃瓜视频娱乐八卦热点聚合插画"
              className="h-[460px] w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-transparent to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-6">
              <div>
                <p className="text-xs font-medium text-background-100">本周焦点 · 已更新 {totalCount}+ 条</p>
                <p className="mt-1 font-heading text-xl font-extrabold text-background-50">
                  年度综艺名场面大赏
                </p>
              </div>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-400 text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
            </div>
          </div>
          <div className="absolute -right-4 -top-5 flex items-center gap-2 rounded-2xl border border-background-200 bg-background-50 px-4 py-3 shadow-soft">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-fire-fill"></i>
            </span>
            <div className="leading-tight">
              <p className="text-xs text-foreground-600">热搜第一</p>
              <p className="text-sm font-bold text-foreground-950">982.3万热度</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}